import { createContext } from "react"

const Playing = createContext()

export default Playing
